import { useEffect } from "react";
import { useOktaAuth } from "@okta/okta-react";
import { useQuery } from "@tanstack/react-query";
import { authClient } from "@lib/okta";

export interface OktaUserProfile {
  given_name?: string;
  [key: string]: unknown;
}

export const useOktaUser = () => {
  const { authState } = useOktaAuth();

  // If auth state changes to not authenticated, invalidate user profile
  useEffect(() => {
    if (authState?.isAuthenticated === false) {
      // Clear user profile from cache when logged out
      authClient.tokenManager.clear();
    }
  }, [authState?.isAuthenticated]);

  return useQuery({
    queryKey: ["oktaUser"],
    queryFn: async () => {
      if (!authState?.isAuthenticated) {
        return null;
      }
      return await authClient.getUser();
    },
    select: (data: OktaUserProfile | null) => ({
      userProfile: data,
      firstName: data?.given_name,
    }),
    // Only run the query when authentication state is determined
    enabled: authState?.isAuthenticated !== undefined,
    // Keep the data fresh for the session
    staleTime: Infinity,
  });
};
